import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'fury-claim-status-history-table',
  templateUrl: './claim-status-history-table.component.html',
  styleUrls: ['./claim-status-history-table.component.scss']
})
export class ClaimStatusHistoryTableComponent implements OnInit {
  @Input() displayedColumns: any[];
  @Input() dataSource: any[] = [];
  
  constructor(
    public commonService: CommonService
  ) { }

  ngOnInit(): void {
  }

}
